import { Component } from '@angular/core';
import { fromEvent } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  public isSpinner = true;

  ngOnInit() {
    // this.isSpinner = false
    fromEvent(window, 'load').subscribe(() => {document.querySelector('#glb-loader')?.classList.remove('loaderShow');});
  }
}
